<template>
  <div class="row" v-if="results && generalInfo">
    <div class="col-12 col-lg-8">
      <div class="font-weight-600 ml-2 mb-4">О кандидате</div>

      <div v-if="results && generalInfo" class="d-flex flex-column profile-card">
        <div class="row w-100">
          <div class="profile-item-title">Текущая должность</div>
          <div class="profile-item-value">
            <v-text-field :value="item.position" @input="onInput('position', $event)"
                :error-messages="fieldErrors('position')" outlined dense _hide-details
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Уровень опыта</div>
          <div class="profile-item-value">
            <v-text-field :value="item.experience" @input="onInput('experience', $event)"
                :error-messages="fieldErrors('experience')" outlined dense _hide-details
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Сфера деятельности</div>
          <div class="profile-item-value">
            <v-text-field :value="item.sphere" @input="onInput('sphere', $event)"
                :error-messages="fieldErrors('sphere')" outlined dense _hide-details
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Hard Skills</div>
          <div class="profile-item-value">
            <v-textarea :value="item.hard_skills" @input="onInput('hard_skills', $event)"
                :error-messages="fieldErrors('hard_skills')" outlined dense _hide-details rows="2" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Soft Skills</div>
          <div class="profile-item-value">
            <v-textarea :value="item.soft_skills" @input="onInput('soft_skills', $event)"
                :error-messages="fieldErrors('soft_skills')" outlined dense _hide-details rows="2" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Знание языков</div>
          <div class="profile-item-value">
            <v-textarea :value="item.languages" @input="onInput('languages', $event)"
                :error-messages="fieldErrors('languages')" outlined dense _hide-details rows="1" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Образование</div>
          <div class="profile-item-value">
            <v-textarea :value="item.diplomas" @input="onInput('diplomas', $event)"
                :error-messages="fieldErrors('diplomas')" outlined dense _hide-details rows="1" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Сертификаты</div>
          <div class="profile-item-value">
            <v-textarea :value="item.certificates" @input="onInput('certificates', $event)"
                :error-messages="fieldErrors('certificates')" outlined dense _hide-details rows="1" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Участие в проектах</div>
          <div class="profile-item-value">
            <v-textarea :value="item.projects" @input="onInput('projects', $event)"
                :error-messages="fieldErrors('projects')" outlined dense _hide-details rows="2" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Локация</div>
          <div class="profile-item-value">
            <v-text-field :value="item.location" @input="onInput('location', $event)"
                :error-messages="fieldErrors('location')" outlined dense _hide-details
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title">Комментарии</div>
          <div class="profile-item-value">
            <v-textarea :value="item.comment" @input="onInput('comment', $event)"
                :error-messages="fieldErrors('comment')" outlined dense _hide-details rows="4" auto-grow
              />
          </div>
        </div>

        <div class="row w-100">
          <div class="profile-item-title"></div>
            <div class="profile-item-value d-flex justify-end">
              <v-btn @click="save()" class="mb-1" color="primary" dense :loading="loading.saveProfile" :disabled="!this.$v.$anyDirty">
                Сохранить
              </v-btn>
            </div>
          </div>
        </div>

      </div>
    <!-- <MessageDialog v-model="showSessionError" :text="strSessionError" /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { maxLength } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
// import MessageDialog from '@/components/ui/MessageDialog';
const maxLenField = 1024;

export default {
  name: 'ProfileData',
  components: {
    // MessageDialog
  },
  props: {
  },
  validations: {
    item: {
      position: { maxLength: maxLength(maxLenField) },
      experience: { maxLength: maxLength(maxLenField) },
      sphere: { maxLength: maxLength(maxLenField) },
      hard_skills: { maxLength: maxLength(maxLenField) },
      soft_skills: { maxLength: maxLength(maxLenField) },
      languages: { maxLength: maxLength(maxLenField) },
      diplomas: { maxLength: maxLength(maxLenField) },
      certificates: { maxLength: maxLength(maxLenField) },
      projects: { maxLength: maxLength(maxLenField) },
      location: { maxLength: maxLength(maxLenField) },
      comment: { maxLength: maxLength(maxLenField) },
    },
  },
  data: () => ({
    item: {
      position: '',
      experience: '',
      sphere: '',
      hard_skills: '',
      soft_skills: '',
      languages: '',
      diplomas: '',
      certificates: '',
      projects: '',
      location: '',
      comment: '',
    }
  }),
  computed: {
    ...mapGetters({
      loading: 'users/candidate/loading',
      results: 'users/candidate/results',
    }),
    isProfile() {
      return this.$route.name === 'profile';
    },
    generalInfo() {
      return this.results?.general_info;
    },
  },
  methods: {
    ...mapActions({
      saveCandidateProfile: 'users/candidate/saveCandidateProfile',
      loadCandidateProfile: 'users/candidate/loadCandidateProfile',
    }),
    ...mapMutations({
    }),
    onInput(field, value) {
      this.$v.item[field].$touch();
      this.item[field] = value;
    },
    fieldErrors(field) {
      const errors = [];
      if (!this.$v.item[field].$dirty) return errors;
      if (!this.$v.item[field].maxLength) errors.push(`Максимальная длина - ${maxLenField} символов`);
      return errors;
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid || this.loading.saveProfile) {
        return;
      }
      const response = await this.saveCandidateProfile({ id: this.$route.params.id, profile: this.item });
      if (response) {
        this.$v.$reset();
      }
      // const form = {
      //   ...this.editedItem,
      //   position: this.editedItem.position,
      //   manager: this.editedItem.managerId,
      // };
      // this.createCandidate(form).then(() => {
      //   this.dialogCreateShow = false;
      // });
    }
  },
  async mounted() {
    const response = await this.loadCandidateProfile(this.$route.params.id);
    console.log('mounted', response);
    if (response) {
      this.item = cloneDeep(response);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";

.profile-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px;
  gap: 1px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05), 2px 0px 4px rgba(0, 0, 0, 0.05), -2px 0px 2px rgba(3, 3, 15, 0.05);
  border-radius: 4px;
  margin: 4px;
  padding: 36px 20px;
}

.profile-item-title {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  flex: 0 0 250px;
  width: 300px;
  // color: #25325F;
  padding: 8px 5px 0 25px;
}

.profile-item-value {
  flex: 0 0 calc(100% - 300px);
  width: calc(100% - 250px);
  // color: #25325F;
  padding: 0x 5px 0 5px;
}

@media screen and (max-width: 800px) {
  .profile-card {
    flex-wrap: wrap;
  }
  .profile-item-title {
    flex: 0 0 100%;
    width: 100%;
    padding: 8px 5px 0 15px;
  }
  .profile-item-value {
    flex: 0 0 100%;
    width: 100%;
    padding-left: 15px;
  }
}

</style>
